/** ****Function is driver function for authenticate*******
 * ****user and route for which it will**************
 * ****return true and false************************** */

import { getLocalStorageToken } from "./common.util";

/**
 * Function: authDriver
 * Description: Driver function for authentication.
 * Determines whether the user is authorized for a given route and user type.
 * @param {Object} route - The route object containing authentication requirements.
 * @param {Object} userData - User data object.
 * @param {String} pathname - Current route pathname.
 * @returns {Boolean} - Returns true if authorized, false otherwise.
 */
function authDriver(route, userData, pathname) {
  try {
    // Get authentication token from local storage
    let checkData = getLocalStorageToken();
    let user = "";

    // Determine user type based on route pathname
    if (pathname.search("backend-hf8a2w-91zj1b") >= 0) {
      user = "admin";
    } else {
      user = "user";
    }
    // Determine user role (admin or user)
    const Role = userData?.user?.role === "admin" ? "admin" : "user";

    // Choose the user type for checking authorization
    let userCheck = Role ?? user;

    if (userCheck === "user" && route?.common === true) {
      // Common route accessible to both admin and user
      return true;
    } else if (route.private && Role === user) {
      // Secure route accessible to the specified user type
      if (!!checkData) {
        return true;
      } else {
        return false;
      }
    } else {
      // Non-secure route
      if (!!checkData) {
        return false;
      }
      if (route.private === false) {
        // Non-private route accessible without authentication
        return true;
      } else {
        // Private route inaccessible without authentication
        return false;
      }
    }
  } catch (err) {
    // Return false in case of any errors
    return false;
  }
}

// Export the authentication driver function
export default authDriver;
